export default __webpack_public_path__ + "assets/dawn.04058193.png";